import React from 'react';
import { NLink } from 'nayan';
import { CONFIG } from '../../config/Config.ts';

const Downloads = () => {
  return (
    <section className="bg-card flex flex-col justify-center text" id="downloads">
      <div className="container mx-auto">
        <div className="text-3xl text text-center mt-12 mb-5">Downloads</div>
        <div className="text text-base mb-8 text-center max-w-[900px] mx-auto">
          Get Kidster now and make learning fun for your kids! With pictorial lessons, stories, puzzles, and games, Kidster offers an interactive way
          to boost your child’s creativity and knowledge. Safe, smart, and easy to use – download today!
        </div>
        <div className="mb-16 text-center flex-1 flex flex-row justify-center items-center">
          <NLink href={CONFIG.PLAY_STORE_URL} target="_blank">
            <img className="image-container h-[50px] w-auto " src="/play-store.png" alt="Worklage playstore" />
          </NLink>
          {/*<NLink href={CONFIG.PLAY_STORE_URL} target="_blank" className="ml-3">*/}
          {/*  <img className="image-container h-[50px] w-auto" src="/app-store.png" alt="Worklage playstore" />*/}
          {/*</NLink>*/}
        </div>
      </div>
    </section>
  );
};

export default Downloads;
